import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { useQuery } from 'react-query';
import { dashboardApi } from '../../../../../api/dashboard';
import { ScaleLoader } from 'react-spinners';

const CompletionRateChart = () => {
  const { data: departmentData, isLoading } = useQuery(
    ['admin-dashboard-completion-by-department'],
    () => dashboardApi.getCompletionByDepartment(),
    {
      cacheTime: 300000,
      staleTime: 300000,
      refetchOnWindowFocus: false,
      select: (res) => res?.data,
    }
  );

  // Normalize API data to chart format
  const chartData = Array.isArray(departmentData)
    ? departmentData.map((item) => ({
        department: item?.department ?? item?.name ?? 'Unknown',
        completion: item?.completionRate ?? item?.completion ?? 0,
      }))
    : [];

  const maxValue = chartData.length
    ? Math.max(...chartData.map((d) => d.completion), 60)
    : 60;

  const tickStep = Math.ceil(maxValue / 4);
  const tickValues = [0, tickStep, tickStep * 2, tickStep * 3, maxValue];

  return (
    <div className="bg-white p-4 shadow rounded-lg w-full h-[350px] flex flex-col">
      <h3 className="text-sm font-medium text-gray-700 mb-2">Completion Rate by Department</h3>

      {isLoading ? (
        <div className="flex-1 flex items-center justify-center">
          <ScaleLoader color="#0A3059" height={30} />
        </div>
      ) : chartData.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-gray-400 text-sm">
          No department data available
        </div>
      ) : (
        <div className="flex-1">
          <ResponsiveBar
            data={chartData}
            keys={['completion']}
            indexBy="department"
            margin={{ top: 20, right: 10, bottom: 40, left: 40 }}
            padding={0.3}
            valueScale={{ type: 'linear', max: maxValue }}
            indexScale={{ type: 'band', round: true }}
            colors="#0A3059"
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 0,
              tickPadding: 10,
              tickRotation: -20,
            }}
            axisLeft={{
              tickSize: 0,
              tickPadding: 10,
              tickRotation: 0,
              format: value => `${value}%`,
              tickValues,
            }}
            enableLabel={false}
            role="application"
            ariaLabel="Completion Rate by Department"
            gridYValues={tickValues}
            theme={{
              grid: {
                line: {
                  stroke: '#e5e7eb',
                  strokeWidth: 1,
                  strokeDasharray: '4 4',
                },
              },
              axis: {
                ticks: {
                  text: {
                    fill: '#6b7280',
                    fontSize: 10,
                  },
                },
              },
            }}
            tooltip={({ id, value, color, indexValue }) => (
              <div className="bg-white p-2 shadow rounded text-xs flex items-center gap-2 border border-gray-100">
                <strong className="text-gray-800">{indexValue}:</strong>{' '}
                <span style={{ color }}>{value}%</span>
              </div>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default CompletionRateChart;
